export const cycleType = new Map([
  [1, '天'],
  [2, '周'],
  [3, '月']
])
